import React, {Component} from 'react';
import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import __ from '../utils/translator';
import Modal from './Modal';
import JwtStore from '../flux/JwtStore';
import CardTitle from "./CardTitle";
import Card from "./Card";
import remToPixels from "../utils/remToPixels";
import Button from "./Button";
import {Link} from "react-router-dom";
import PropTypes from 'prop-types';
import Close from "../icons/Close";
import RenderOnTablet from "./responsive/RenderOnTablet";
import RenderOnMobile from "./responsive/RenderOnMobile";
import ModalFullscreenActions from "../flux/ModalFullscreenActions";
import getNotificationSessionStorageKey
  from '../utils/getNotificationSessionStorageKey';

function resizeCover(cover) {
  return cover.replace('0x0', `${remToPixels(45)}x${remToPixels(45)}`);
}

function getLocalStorageKey(username) {
  return `news_displayed_${username}`;
}

class NotificationModal extends Component {

  state = {
    notificationModalShowed: window.sessionStorage.getItem(getNotificationSessionStorageKey(JwtStore.getUsername())),
    newsDisplayed: window.localStorage.getItem(getLocalStorageKey(JwtStore.getUsername())),
    currentIndex:0,
    contents: [],
  }

  subscriptions = [];

  constructor(props){
    super(props);
    this.onGoToMyProfilePageClick= this.onGoToMyProfilePageClick.bind(this);
    this.onGoToProductFocus=this.onGoToProductFocus.bind(this);
    this.onGoToMobileNewsClick=this.onGoToMobileNewsClick.bind(this);
  }

  componentDidMount() {
    let contents=[];
    contents = contents.concat(this.props.unseenProductFocus);

    if(this.props.hasNews && ! this.state.newsDisplayed){
      contents.push({type: 'news'})
    }

    this.setState({
      contents
    });
  }

  onGoToProductFocus(){
    this.setState({ notificationModalShowed: true });
  }

  onGoToMyProfilePageClick(){
    this.updateNewsAndModalState();
  }

  onGoToMobileNewsClick(){
    this.updateNewsAndModalState();
    ModalFullscreenActions.news();
  }

  updateNewsAndModalState(){
    this.setState({ newsDisplayed: true, notificationModalShowed:true }, () => {
      window.localStorage.setItem(getLocalStorageKey(JwtStore.getUsername()), "1");
    });
  }

  setSessionStorageWithUsername() {
    window.sessionStorage.setItem(getNotificationSessionStorageKey(JwtStore.getUsername()), "1");
  }

  componentWillUnmount() {
    this.subscriptions.forEach(subscription => subscription.remove());
  }

  render() {
    if (this.state.contents.length === 0 || this.state.notificationModalShowed) {
      return null;
    }

    return (
      <Modal style={{
        maxWidth: '24rem',
        margin: '.5rem',
        padding: 0,
        backgroundColor: '#fff'
      }}>
        <div style={{ marginLeft: 'auto', padding: '1rem 1rem' }}>
          <CloseIcon onClick={() => {
            this.setState({contents: [], currentIndex: 0})
            this.setSessionStorageWithUsername();
          }}/>
        </div>
        <ModalBody>
          <StyledSwiper
            key={this.state.contents.length}
            slidesPerView={1}
            pagination={this.state.contents.length > 1 ? {clickable: true}: false}
            spaceBetween={8}
          >
            {this.state.contents.map( (content, index) => (
              <SwiperSlide index={index} key={index}>
                  {content.type === 'news' ? (
                    <Content style={{justifyContent: 'flex-end'}}>
                      <span style={{display: 'flex', flexGrow: 1, alignItems: 'center'}}>
                        {__('Check out the news feed in your profile!')}
                      </span>
                      <RenderOnTablet>
                        <Link to="/profile"
                              style={{width: '100%'}}>
                          <ButtonNotification size="large" onClick={this.onGoToMyProfilePageClick}>
                            {__('Go')}
                          </ButtonNotification>
                        </Link>
                      </RenderOnTablet>
                      <RenderOnMobile>
                        <ButtonNotification size="large" onClick={this.onGoToMobileNewsClick}>
                          {__('Go')}
                        </ButtonNotification>
                      </RenderOnMobile>
                    </Content>
                  ) : content.cover !== null ? (
                    <Content>
                      <span>{__('New product focus')}: {content.name}</span>
                      <Card
                        key='1'
                        style={{padding: '1rem 0', flex: 1, border: '0', width: '100%'}}
                        linkTo={`product-focuses/${content.id}`}
                        cover={resizeCover(content.cover)}>
                        <CardTitle small style={{textTransform: 'uppercase',}}>
                          {content.name}
                        </CardTitle>
                      </Card>
                      <Link to={`product-focuses/${content.id}`}
                            onClick={this.onGoToProductFocus}
                            style={{width: '100%'}}>
                        <ButtonNotification size="large">
                          {__('Discover')}
                        </ButtonNotification>
                      </Link>
                    </Content>
                  ) : null
                  }
              </SwiperSlide>
            ))}
          </StyledSwiper>
        </ModalBody>
      </Modal>
    );
  }
}

const ModalBody = styled.div`
  width: 100%;
  min-height: 24rem;
  display: flex;
  justify-content: center;

  svg {
    width: 1.4rem;
  }
`;

const StyledSwiper = styled(Swiper)`
  width: 100%;
  padding-bottom: 2rem;

  >.swiper-pagination-bullets {
    bottom: 1rem;
  }

   >.swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0 .25rem;
  }

  .swiper-pagination-bullet {
    background-color: #8B8B8B;
    opacity: .7;
    margin: 0;
  }

  .swiper-pagination-bullet-active {
    background-color: #000;
    opacity: 1;
  }
`;


const Content = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;

  > span {
    text-align: center;
    font-size: 1.16rem;
    letter-spacing: .1rem;
    text-transform: uppercase;
  }
`;

const ButtonNotification = styled(Button)`
  width: 100%;
  background-color: #000;
  color: #fff;
`;

const CloseIcon = styled(Close)`
  width: 1.4rem;
  cursor: pointer;
`;

NotificationModal.propTypes = {
  hasNews: PropTypes.bool,
  unseenProductFocuses: PropTypes.arrayOf(PropTypes.object),
};

export default NotificationModal;
